/**
 *
 * 刷新重连mixins
 */

/**
 * 重连的条件
 * 1.用户已经登陆
 * 2.用户已经选择了技能组
 * 3.用户已经点击跳过进入到了聊天页面
 * 4.在conversation路由
 * 5.用户直接进入的人工客服
 *
 * 后期对这几个状态进行优化
 * 后期优化： 只要用户在连接状态就重连 其余状态都不需要
 */
import service from "src/app/customer/service";
import { getDoMain } from "src/app/customer/utils";
import socket from "src/utils/socket";
import { canAcceptThisMessage } from "src/app/customer/utils/message";

export default {
  computed: {
    ...mapState({
      questionText: state => state.questionText,
      isPerson: state => state.isPerson,
      isJump: state => state.isJump,
      orderImgUrls: state => state.orderImgUrls,
      userId: state => state.urlData.userId,
      enterScene: state => state.urlData.enterScene,
      isreenter: state => state.isreenter,
      isQueue: state => state.isQueue,
      dialogtime: state => state.dialogtime
    }),
    ...mapGetters(["isLogin"])
  },
  methods: {
    scrollBottom() {
      this.$nextTick(() => {
        const messageBox = document.querySelector("#messageBox");
        setTimeout(() => {
          messageBox.scrollTop = messageBox.scrollHeight + 200;
        }, 10);
      });
    }
  },
  async mounted() {
    this.$store.commit("setState", {
      listStatus: false
    });
    const routerName = this.$router.currentRoute.name;
    const flag = routerName === "conversation" && this.isLogin;
    if (routerName === "before-page") {
      await getDoMain();
    }
    if (this.isreenter == 1 && flag) {
      await getDoMain();
      let invalidFlag = service.getquerySessionValid({
        userId: this.userId,
        enterScene: this.enterScene
      });
      invalidFlag.then(res => {
        if (flag && res.data.invalidFlag == 1) {
          console.log("有效");

          if (canAcceptThisMessage(this.$store.state.userId)) {
            //刷新重连
            this.$store.dispatch("initChannel", {
              orderImgUrls: this.orderImgUrls
            });
          }

          this.$store.commit("setState", {
            beginTime: 0
          });
          this.$store.commit("clearAllMessages");
          this.$store.dispatch("getMessages");
          this.scrollBottom();
        } else if (res.data.invalidFlag == 2 && this.isQueue) {
          console.log("无效");
          this.$store.commit("setState", {
            dialogtime: true
          });
        } else if (
          res.data.invalidFlag == 2 &&
          !this.isQueue &&
          this.$store.state.blackFlag === 0
        ) {
          this.$store.commit("setState", {
            isConversation: false,
            isShowEvaluatePage: true,
            beginTime: 0
          });
          this.$store.dispatch("getMessages");
        } else if (res.data.invalidFlag == 3) {
          socket.initSocket();
        }
      });
    }
  }
};
